<template>
  <div class="book-list flex">
    <template v-for="(item,index) in list" >
      <book-item :item="item" v-if="index<showNum" :key="index"/>
    </template>
  </div>
</template>

<script>
import BookItem from './BookItem.vue'
export default {
  components: { BookItem },
  name: 'CardBook',
  props: { list:Array},
  data(){
    return{
      showNum:5,
    }
  },
methods:{

},
}
</script>
<style scoped lang="scss">
  .book-list{
    width: 100%;
  }

</style>